import { API_URL, jwtToken } from "../../../context/appContext";
export default async function removeAccumulatorCase(data) {
    return fetch(`${API_URL}/api/accumulator_remove_edge_case_process`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        }, body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => console.log({ err }))
}
